import { createStyles, makeStyles } from '@material-ui/styles';
import classNames from 'classnames';
import * as React from 'react';
import mediaQueries from '../constants/responsive';
import spacing from '../constants/spacing';
import stylesheet from '../constants/stylesheet';

export type PanelTitlePros = PanelTitleDto;

const useStyles = makeStyles(() =>
    createStyles({
        panelItem: {
            boxSizing: 'border-box',
            [mediaQueries.Mobile]: {
                paddingBottom: spacing.Gutter.Mobile,
                paddingRight: spacing.Gutter.Mobile / 2,
                paddingLeft: spacing.Gutter.Mobile / 2,
            },
            [mediaQueries.Tablet]: {
                paddingBottom: spacing.Gutter.Tablet,
                paddingRight: spacing.Gutter.Tablet / 2,
                paddingLeft: spacing.Gutter.Tablet / 2,
            },
            [mediaQueries.AfterTablet]: {
                paddingBottom: spacing.Gutter.Desktop,
                paddingRight: spacing.Gutter.Desktop / 2,
                paddingLeft: spacing.Gutter.Desktop / 2,
            },
        },
        panelFull: {
            width: '100%'
        },
        panelHalf: {
            width: '50%'
        },
        title: {
            width: '100%',
            textAlign: 'center',
            [mediaQueries.Mobile]: {
                ...stylesheet.TextStyleTwo
            },
            [mediaQueries.Tablet]: {
                ...stylesheet.TextStyleTwo
            },
            [mediaQueries.AfterTablet]: {
                ...stylesheet.TextStyleOne
            },
        },
        titleMobile: {
            width: '100%',
            textAlign: 'center',
            display: 'none',
            [mediaQueries.Mobile]: {
                display: 'block',
                ...stylesheet.TextStyleTwo
            },
        }
    }));

const PanelTitle: React.FC<PanelTitlePros> = ({ Title, TitleMobile, Size }) => {
    const cls = useStyles();

    return (
        <div
            className={
                classNames(
                    cls.panelItem,
                    Size === "Full" ? cls.panelFull : cls.panelHalf)}
        >
            <h2 className={cls.title}>{Title}</h2>
        </div>
    );
}

export default PanelTitle;